import Flickity from 'flickity';
import enquire from 'enquire.js';
import { breakpoints } from '../../utils';

export default(() => {
    const carousels = Array.from(document.querySelectorAll('.js-news'));

    carousels.forEach((carousel) => {
        const selector = carousel.dataset.selector || '.card';

        const flkty = new Flickity(carousel, {
            cellSelector: selector,
            cellAlign: 'left',
            prevNextButtons: false,
            pageDots: false,
            contain: carousel.dataset.selector === '.panel'
        });

        const parent = carousel.closest('.news');
        const prevButton = parent.querySelector('.news__pagination-prev');
        const nextButton = parent.querySelector('.news__pagination-next');

        if (prevButton) {
            prevButton.addEventListener('click', () => {
                flkty.previous();
            });
        }

        if (nextButton) {
            nextButton.addEventListener('click', () => {
                flkty.next();
            });
        }


        if (prevButton && nextButton) {
            // Hide nav based on media query and slide qty
            const toggleNav = (limit) => {
                if (flkty.slides.length > limit) {
                    prevButton.style.display = 'flex';
                    nextButton.style.display = 'flex';
                } else {
                    prevButton.style.display = 'none';
                    nextButton.style.display = 'none';
                }
            }

            enquire.register(breakpoints['desk'], {
                match() {
                    toggleNav(3)
                }
            });

            enquire.register(breakpoints['lap'], {
                match() {
                    toggleNav(2)
                }
            });

            enquire.register(breakpoints['palm'], {
                match() {
                    toggleNav(1)
                }
            });
        }

    });
})();
